import capitalize from 'lodash/capitalize.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoToggle from '../../components/toggle/pendo-toggle.vue.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';
import PendoCard from '../../components/card/pendo-card.vue.js';
import AgentSettingsModal from './agent-settings-modal.vue.js';
import PendoLegalAcknowledgement from '../legal-acknowledgement/pendo-legal-acknowledgement.vue.js';

var script = {
  name: 'PendoEnvironmentSettings',
  components: {
    PendoButton,
    PendoIcon,
    PendoCard,
    PendoToggle,
    PendoLegalAcknowledgement,
    AgentSettingsModal
  },
  props: {
    isPendoEnabled: {
      type: Boolean,
      required: true
    },
    pendoDisabledText: {
      type: String,
      default: ''
    },
    enableLaunchDebugger: {
      type: Boolean,
      default: false
    },
    isAgentSettingsModalVisible: {
      type: Boolean,
      default: false
    },
    isSaveLoading: {
      type: Boolean,
      default: false
    },
    isConfirmationModalVisible: {
      type: Boolean,
      default: false
    },
    isConfirmLoading: {
      type: Boolean,
      default: false
    },
    staging: {
      type: Object,
      default: () => ({})
    },
    production: {
      type: Object,
      default: () => ({})
    },
    agentVersions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      agentSettings: {}
    };
  },
  computed: {
    envs() {
      const envs = [this.production];
      if (this.staging) {
        envs.unshift(this.staging);
      }
      return envs;
    }
  },
  methods: {
    displayTitle(_ref) {
      let {
        description
      } = _ref;
      return `${capitalize(description)} Environment`;
    },
    displayAgentPolicy(_ref2) {
      let {
        agentPolicy
      } = _ref2;
      return `Latest ${capitalize(agentPolicy)} Agent Version`;
    },
    deprecatedAgentVersionText(_ref3) {
      let {
        agentVersion
      } = _ref3;
      return `Agent ${agentVersion} is deprecated. Update to a newer version for the best experience.`;
    },
    openAgentSettingsModal(_ref4) {
      let {
        description
      } = _ref4;
      this.agentSettings = description === 'staging' ? this.staging : this.production;
      this.$emit('openAgentSettingsModal');
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-environment-settings.vue2.js.map
